import { Outlet, Navigate } from "react-router-dom";
const ProtectedRoute = ({logInStatus}) =>{
    return logInStatus ? <Outlet/> : <Navigate to='/'/>
}

export default ProtectedRoute